import * as hooks from '@wordpress/hooks';
import { LocationItem } from './components/LocationItem';
import { LocationDetails } from './components/LocationDetails';
import { SplashHero } from './components/SplashHero';
const { addFilter } = hooks;

interface Filters {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	[key: string]: any;
}

const filters: Filters = {
	'component.LocationItem': LocationItem,
	'component.LocationDetails': LocationDetails,
	'component.SplashHero': SplashHero,
	'data.filter-locations-available-radiuses': [10, 25, 50, 100, 250, 500],
};

for (const hook in filters) {
	addFilter(hook, 'vib', () => filters[hook], 1);
}

window.findaWpHooks = hooks;
